import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = ({ footer }) => {
    const year = new Date().getFullYear();
    const disclosures = [
        { title: footer.affiliate_title, text: footer.affiliate_text, testId: "footer-affiliate-disclosure" },
        { title: footer.medical_title, text: footer.medical_text, testId: "footer-medical-disclaimer" },
        { title: footer.advertising_title, text: footer.advertising_text, testId: "footer-advertising-notice" },
    ];
    return (
        <footer data-testid="site-footer" className="mt-8 bg-[#222522] text-[#FDFCF8]">
            <div className="max-w-[760px] mx-auto px-4 sm:px-6 py-14">
                <Logo light />
                <nav className="mt-6 flex flex-wrap gap-x-6 gap-y-2">
                    <Link to="/tools" data-testid="footer-tools-link" className="text-xs font-semibold text-[#DDE5DB] transition-colors hover:text-white">Free tools & templates</Link>
                    <Link to="/tools/breath-score" data-testid="footer-score-link" className="text-xs font-semibold text-[#DDE5DB] transition-colors hover:text-white">Breath score calculator</Link>
                    <Link to="/guides/halitosis-science" data-testid="footer-guide-link" className="text-xs font-semibold text-[#DDE5DB] transition-colors hover:text-white">Deep-dive guide</Link>
                    <a href="/api/tracker.pdf" data-testid="footer-tracker-link" className="text-xs font-semibold text-[#DDE5DB] transition-colors hover:text-white">7-day tracker (PDF)</a>
                </nav>
                <div className="mt-10 grid gap-8 sm:grid-cols-3">
                    {disclosures.map((d) => (
                        <div key={d.title} data-testid={d.testId}>
                            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#9AB098]">{d.title}</h4>
                            <p className="mt-3 text-xs leading-relaxed text-[#FDFCF8]/60">{d.text}</p>
                        </div>
                    ))}
                </div>
                <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/10 pt-6">
                    <p className="text-xs text-[#FDFCF8]/50">© {year} SmartBreathCheck. All rights reserved.</p>
                    <Link
                        to="/settings"
                        data-testid="footer-owner-settings-link"
                        className="text-xs font-semibold text-[#9AB098] underline-offset-4 transition-colors hover:text-[#DDE5DB] hover:underline"
                    >
                        Owner settings
                    </Link>
                </div>
            </div>
        </footer>
    );
};
